function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu_outline_28"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,20 C23.0522847,20 23.5,20.4477153 23.5,21 C23.5,21.5522847 23.0522847,22 22.5,22 L22.5,22 L5.5,22 C4.94771525,22 4.5,21.5522847 4.5,21 C4.5,20.4477153 4.94771525,20 5.5,20 L5.5,20 Z M22.5,13 C23.0522847,13 23.5,13.4477153 23.5,14 C23.5,14.5522847 23.0522847,15 22.5,15 L22.5,15 L5.5,15 C4.94771525,15 4.5,14.5522847 4.5,14 C4.5,13.4477153 4.94771525,13 5.5,13 L5.5,13 Z M22.5,6 C23.0522847,6 23.5,6.44771525 23.5,7 C23.5,7.55228475 23.0522847,8 22.5,8 L22.5,8 L5.5,8 C4.94771525,8 4.5,7.55228475 4.5,7 C4.5,6.44771525 4.94771525,6 5.5,6 L5.5,6 Z",
  id: "\\u21B3-Icon-Color",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.baf1bd8a.svg";
export { ForwardRef as ReactComponent };